<template>
  <div class="kanban-container p-3">
    <b-row class="flex-nowrap overflow-auto" no-gutters>
      <b-col
        v-for="column in localColumns"
        :key="column.id"
        class="kanban-col"
      >
        <b-card no-body class="h-100 bg-light overflow-hidden">
          <b-card-header :class="`border-${column.variant} font-weight-bold text-center`">
            {{ column.title }}
            <b-badge pill :variant="column.variant">{{ column.items.length }}</b-badge>
          </b-card-header>
          <b-card-body class="p-1 h-100 min-h-200">
            <draggable
              v-model="column.items"
              :group="groupName"
              @change="(evt) => onItemMoved(evt, column.id)"
              animation="200"
              ghost-class="ghost-card"
              class="h-100"
            >
              <div
                v-for="item in column.items"
                :key="item.id"
                class="mb-2"
              >
                <slot name="card" :item="item">
                </slot>
              </div>
            </draggable>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: 'Kanban',
  components: { draggable },
  props: {
    items: { type: Array, default: () => [] },
    columns: { type: Array, required: true },
    groupName: { type: String, default: 'kanban-group' }
  },
  data() {
    return {
      localColumns: []
    };
  },
  methods: {
    throwItemsToColumns(items) {
      const newColumns = this.columns.map(col => ({ ...col, items: [] }));

      if (items && items.length) {
        items.forEach(item => {
          const targetCol = newColumns.find(col => col.id === item.status);
          if (targetCol) {
            targetCol.items.push(item);
          }
        });
      }

      this.localColumns = newColumns;
    },
    onItemMoved(evt, newStatusId) {
      if (evt.added) {
        const item = evt.added.element;
        this.$emit('status-updated', {
          item: item,
          newStatus: newStatusId,
          oldStatus: item.status
        });
      }
    }
  },
  watch: {
    items: {
      handler(newItems) {
        this.throwItemsToColumns(newItems);
      }, deep: true, immediate: true
    },
    columns: {
      handler() {
        this.throwItemsToColumns(this.items);
      }, deep: true
    }
  },
};
</script>

<style scoped>
.ghost-card {
  opacity: 0.5;
  background: #c8ebfb;
  border: 1px dashed #4169E1;
  border-radius: 3px;
}

.kanban-col {
  min-width: 300px;
  max-width: 305px;
}

.min-h-200 {
  min-height: 200px !important;
}

.kanban-container {
  min-height: calc(150vh - 500px);
  background-color: #f8f9fa;
}
</style>



// WEBPACK FOOTER //
// src/utilites/commonUi/Kanban.vue